module.exports = __webpack_public_path__ + "img/QQZone.4c0dd1cd.png";